import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledContainer = styled(Container)(({ theme }) => ({
  '& .APFFormContiner': {
    width: theme.spacing(87.5),
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      marginBottom: theme.spacing(4),
    },
  },
  '& .APFFormHeader': {
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(3),
  },
  '& .APFFormTitle': {
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(2),
  },
  '& .APFFormInput': {
    border: `1px solid ${theme.palette.grey[100]}`,
    '& .MuiFilledInput-root': {
      backgroundColor: theme.palette.common.white,
      '&:before,:after': {
        borderBottom: 0,
      },
      '&:hover': {
        '&:before,:after': {
          borderBottom: 0,
        },
      },
    },
    '& .MuiFilledInput-input': {
      color: theme.palette.secondary.main,
    },
  },
  '& .APFDetailsTitle': {
    margin: theme.spacing(3, 0, 2, 0),
    color: theme.palette.secondary.main,
  },
  '& .APFFormRecaptchaContiner': {
    margin: theme.spacing(2, 0),
    [theme.breakpoints.down('md')]: {
      transform: 'scale(0.95)',
      transformOrigin: '0 0',
    },
  },
}));

export default StyledContainer;
